import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { UserTrackingEvents } from '@revelio/core';

interface UsePageVisitTrackingOptions {
  page: string;
  additionalProps?: {
    page_id?: string;
    page_type?: string;
  };
}

export const usePageVisitTracking = ({
  page,
  additionalProps = {},
}: UsePageVisitTrackingOptions) => {
  const location = useLocation();

  const { page_id, page_type } = additionalProps;

  useEffect(() => {
    mixpanel.track(UserTrackingEvents.PAGE_VISIT, {
      page,
      path: location.pathname,
      page_id,
      page_type,
    });
    mixpanel.time_event(UserTrackingEvents.PAGE_LEAVE);

    return () => {
      mixpanel.track(UserTrackingEvents.PAGE_LEAVE, {
        page,
        path: location.pathname,
        page_id,
        page_type,
      });
    };
  }, [page, location.pathname, page_id, page_type]);
};
